import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import { AmendmentForm } from "../ui/LmsSharedForms";

const MainTable = () => (
  <LmsTable
    actionButtons={["edit", "export"]}
    apiSuffix="amendments/reviews"
    columnLabelsDictionary={{ applicationNumber: "Application #", loanNumber: "Loan #" }}
    skipClick
  />
);

const LmsVotingAmendmentReview = ({ params = {}, history }) => {
  const { isEdit, isMainPage, isActionAllowed, id } = useParseRouteActions(params, ["edit"]);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <MainTable />}
      {isEdit && <AmendmentForm loanId={id} type="edit" />}
    </>
  );
};

export default LmsVotingAmendmentReview;
